<template>
  <div class="latestlog">
    <transition name="fade">
      <div v-if="log" class="title" align="left">
        <h2>Latest logs</h2>
      </div>
    </transition>
    <transition name="fade">
      <LogCard
        v-if="log"
        :log="log"
      />
    </transition>
  </div>
</template>

<script>
import LogCard from './LogCard.vue'
import axios from 'axios'
const apiUrl = 'https://logcrow.appspot.com/'
// const apiUrl = 'http://192.168.212.101:9999/'
// const apiUrl = 'http://localhost:9999/'
export default {
  name: 'LatestLog',
  components: {
    LogCard,
  },
  data() {
    return {
      logs: [],
      currentPage: 0,
      timer: null,
    }
  },
  methods: {
    next() {
      let orig = this.logs
      this.logs = []
      setTimeout(() => {
        this.logs = orig
      }, 1000);
      if( this.currentPage < orig.length - 1 ) {
        this.currentPage += 1
      } else {
        this.currentPage = 0
      }
    },
    getLatestLogs() {
      let search = async () => {
        let res = await axios.get(apiUrl + 'log', {
          params: {
            search: "",
            target: "",
            version: "",
            scope: 'public',
            current_page: 0,
            per_page: 10
          }
        })
        if (res.data.logs) {
          this.logs = res.data.logs
          this.timer = setInterval(() => {
            this.next()
          }, 20000)
        } 
      }
      search()
    }
  },
  computed: {
    log() {
      if( this.logs.length > 0 ) {
        return this.logs[this.currentPage]
      } else {
        return null
      }
    }
  },
  mounted: function() {
    this.getLatestLogs()
  },
  destroyed() {
    clearInterval(this.timer)
  },
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.title {
  padding: 1.5rem;
}
</style>